import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { StatusInfo } from "../models/status-info.model";
import { Observable } from "rxjs";
import { PageResult } from "../models/page-result.model";
import { WorkItem } from "../models/work-item.model";
import { EntityAction } from "../models/entity-action.model";
import { TableConfiguration } from "../models/table-configuration.model";
import { AppSettings } from "../shared/app-settings";

/**
 * Encapsulates home page (work items) related operations.
 */
@Injectable({
  providedIn: 'root',
})
export class HomeService {
  /**
   * Creates an instance of service.
   *
   * @param http HTTP request/response handler.
   */
  constructor(private http: HttpClient) { }

  /**
   * API base URL for home page (work items) related HTTP requests.
   */
  private baseUrl = `${environment.datalabUrl}ui/home`;

  /**
   * Retrieves entities status info.
   *
   * @returns Entities status info.
   */
  getStatusInfo(): Observable<EntityAction<StatusInfo>> {
    return this.http.get<EntityAction<StatusInfo>>(`${this.baseUrl}/status`);
  }

  /**
   * Retrieves page of work items.
   *
   * @param sortBy Name of the field for ordering.
   * @param isDescending Flag which displays if ordering should be descending.
   * @param continuationToken Next page token.
   * @param searchText Is not used here. For interface compatibility
   * @param filters Is not used here. For interface compatibility
   * @returns A page of work items.
   */
  getPage(sortBy: string, isDescending: boolean, searchText: string, filters: string[], continuationToken: string): Observable<PageResult<WorkItem>> {
    let params = new HttpParams();
    params = params.set('sortBy', sortBy);
    params = params.set('isDescending', isDescending.toString());

    let headers = new HttpHeaders();
    if (continuationToken)
      headers = headers.set(AppSettings.continuationTokenHeader, continuationToken);

    return this.http.get<PageResult<WorkItem>>(this.baseUrl, { params, headers });
  }

  /**
   * Retrieves configuration data for work item table with allowed actions list.
   *
   * @returns EntityAction instance with TableConfiguration.
   */
  getConfiguration(): Observable<EntityAction<TableConfiguration>> {
    return this.http.get<EntityAction<TableConfiguration>>(`${this.baseUrl}/configuration`);
  }
}
